import { defineMessages } from 'react-intl';

export const messages: {
	liveDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workItem: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	draftLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description:
			'Content type badge shown on a recent activity result card in the Quick Find dialog to indicate the item is a Live Doc (a collaborative real-time document).',
	},
	workItem: {
		id: 'work_item',
		defaultMessage: 'Work item',
		description:
			'Content type badge shown on a recent activity result card in the Quick Find dialog to indicate the item is a Jira work item.',
	},
	draftLabel: {
		id: 'draft_label',
		defaultMessage: 'Draft',
		description:
			'Status lozenge shown on a recent activity result card in the Quick Find dialog when the item is in draft state and has not been published.',
	},
});
